// extracted by mini-css-extract-plugin
module.exports =  {"CooldownRange__Title":"FsAAhXM8mbqSdRnnMFJW","CooldownRange__Description":"ZJN2TLwg9KDpsEiRKGWr","CooldownRange__Input":"E2lYEJJM74a_Ed977Qrx"};